// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h6[data-v-05ac77ee] {\n  color: var(--dark-green-60, #66827f);\n  font-size: 0.88rem !important;\n  font-weight: 400;\n}\nh6 span[data-v-05ac77ee] {\n  color: var(--dark-green-100, #002e2a);\n}", ""]);
// Exports
module.exports = exports;
